export const LOCALES = ['en', 'es'];
export const PHONE_MIN_LENGTH = 14;

export const US_STATES: { name: string; abbreviation: string; slug: string }[] = [
  { name: 'Alabama', abbreviation: 'AL', slug: 'alabama' },
  { name: 'Alaska', abbreviation: 'AK', slug: 'alaska' },
  { name: 'Arizona', abbreviation: 'AZ', slug: 'arizona' },
  { name: 'Arkansas', abbreviation: 'AR', slug: 'arkansas' },
  { name: 'California', abbreviation: 'CA', slug: 'california' },
  { name: 'Colorado', abbreviation: 'CO', slug: 'colorado' },
  { name: 'Connecticut', abbreviation: 'CT', slug: 'connecticut' },
  { name: 'Delaware', abbreviation: 'DE', slug: 'delaware' },
  { name: 'Florida', abbreviation: 'FL', slug: 'florida' },
  { name: 'Georgia', abbreviation: 'GA', slug: 'georgia' },
  { name: 'Hawaii', abbreviation: 'HI', slug: 'hawaii' },
  { name: 'Idaho', abbreviation: 'ID', slug: 'idaho' },
  { name: 'Illinois', abbreviation: 'IL', slug: 'illinois' },
  { name: 'Indiana', abbreviation: 'IN', slug: 'indiana' },
  { name: 'Iowa', abbreviation: 'IA', slug: 'iowa' },
  { name: 'Kansas', abbreviation: 'KS', slug: 'kansas' },
  { name: 'Kentucky', abbreviation: 'KY', slug: 'kentucky' },
  { name: 'Louisiana', abbreviation: 'LA', slug: 'louisiana' },
  { name: 'Maine', abbreviation: 'ME', slug: 'maine' },
  { name: 'Maryland', abbreviation: 'MD', slug: 'maryland' },
  { name: 'Massachusetts', abbreviation: 'MA', slug: 'massachusetts' },
  { name: 'Michigan', abbreviation: 'MI', slug: 'michigan' },
  { name: 'Minnesota', abbreviation: 'MN', slug: 'minnesota' },
  { name: 'Mississippi', abbreviation: 'MS', slug: 'mississippi' },
  { name: 'Missouri', abbreviation: 'MO', slug: 'missouri' },
  { name: 'Montana', abbreviation: 'MT', slug: 'montana' },
  { name: 'Nebraska', abbreviation: 'NE', slug: 'nebraska' },
  { name: 'Nevada', abbreviation: 'NV', slug: 'nevada' },
  { name: 'New Hampshire', abbreviation: 'NH', slug: 'new-hampshire' },
  { name: 'New Jersey', abbreviation: 'NJ', slug: 'new-jersey' },
  { name: 'New Mexico', abbreviation: 'NM', slug: 'new-mexico' },
  { name: 'New York', abbreviation: 'NY', slug: 'new-york' },
  { name: 'North Carolina', abbreviation: 'NC', slug: 'north-carolina' },
  { name: 'North Dakota', abbreviation: 'ND', slug: 'north-dakota' },
  { name: 'Ohio', abbreviation: 'OH', slug: 'ohio' },
  { name: 'Oklahoma', abbreviation: 'OK', slug: 'oklahoma' },
  { name: 'Oregon', abbreviation: 'OR', slug: 'oregon' },
  { name: 'Pennsylvania', abbreviation: 'PA', slug: 'pennsylvania' },
  { name: 'Rhode Island', abbreviation: 'RI', slug: 'rhode-island' },
  { name: 'South Carolina', abbreviation: 'SC', slug: 'south-carolina' },
  { name: 'South Dakota', abbreviation: 'SD', slug: 'south-dakota' },
  { name: 'Tennessee', abbreviation: 'TN', slug: 'tennessee' },
  { name: 'Texas', abbreviation: 'TX', slug: 'texas' },
  { name: 'Utah', abbreviation: 'UT', slug: 'utah' },
  { name: 'Vermont', abbreviation: 'VT', slug: 'vermont' },
  { name: 'Virginia', abbreviation: 'VA', slug: 'virginia' },
  { name: 'Washington', abbreviation: 'WA', slug: 'washington' },
  { name: 'West Virginia', abbreviation: 'WV', slug: 'west-virginia' },
  { name: 'Wisconsin', abbreviation: 'WI', slug: 'wisconsin' },
  { name: 'Wyoming', abbreviation: 'WY', slug: 'wyoming' },
  { name: 'United Kingdom', abbreviation: 'UK', slug: 'united-kingdom' },
];

export const US_STATES_ABBREVIATIONS = US_STATES.map((state) => state.abbreviation);
export const US_STATES_NAMES = US_STATES.map((state) => state.name);
export const US_STATES_SLUGS = US_STATES.map((state) => state.slug);

export const findStateBySlug = (slug: string) => US_STATES.find((s) => s.slug === slug);

export const findStateByName = (name: string) =>
  US_STATES.find((s) => s.name.toLowerCase() === name.toLowerCase());

export type StateType = { name: string; abbreviation: string; slug: string };

export const COUNTRIES = [
  { name: 'United States', code: 'US' },
  { name: 'United Kingdom', code: 'UK' },
] as const;

export const COUNTRY_CODES = COUNTRIES.map((c) => c.code);
export const COUNTRY_NAMES = COUNTRIES.map((c) => c.name);
export type CountryCode = (typeof COUNTRY_CODES)[number];

export const ContentType = {
  AboutUs: 'About Us',
  FAQ: 'FAQ',
  CaseResults: 'Case Results',
  AccidentTypes: 'Accident Types',
  Founder: 'Founder',
  Footer: 'Footer',
  InjuryTypes: 'Injury Types',
  Injury: 'Injury',
  Navbar: 'Navbar',
  PracticeAreas: 'Practice Areas',
  ProcessSteps: 'Process Steps',
  ReasonsToChooseUs: 'Reasons to Choose Us',
  RecoveryExpertise: 'Recovery Expertise',
  ThingsToKnowAbout: 'Things to Know About',
  WaysToHelp: 'Ways to Help',
} as const;

export const PageTypes = {
  RootLevel: 'root-level',
  GeneralContent: 'general-content',
  LandingPages: 'landing-pages',
  Location: 'location',
  Lawsuit: 'lawsuit',
  PersonalInjury: 'personal-injury',
  ClaimType: 'claim-type',
  ClamSection: 'claim-section',
} as const;

export const EXTENDABLE_PAGE_TYPES = [
  PageTypes.Lawsuit,
  PageTypes.PersonalInjury,
  PageTypes.Location,
] as const;

export type ExtendablePageType = (typeof EXTENDABLE_PAGE_TYPES)[number];

// --- Form Engine and Builder Constants --- //
export enum CriteriaActionType {
  NEXT = 'next',
  NESTED = 'nested',
  STOP = 'stop',
  REDIRECT = 'redirect',
  FINISH = 'finish',
}

export type ActionTypeStopMetadata = { metadata: { message: string; style: string } };
export type ActionTypeRedirectMetadata = { metadata: { url: string } };
export type ActionTypeNoMetadata = {};
export type ActionTypeMetadata =
  | ActionTypeStopMetadata
  | ActionTypeRedirectMetadata
  | ActionTypeNoMetadata;

export type FormActionType = {
  name: CriteriaActionType;
} & ActionTypeMetadata;

export enum CriteriaRuleType {
  SOME_MATCH = 'some-match',
  EVERY_MATCH = 'every-match',
  NONE_MATCH = 'none-match',
}

/** How a `stop` action presents its message. Persisted in `action.metadata.style`. */
export enum FormStopStyle {
  INLINE = 'default',
  POPUP = 'popup',
}

/** Completion message shown once the form reaches its terminal state. */
export enum FormCompletionMessage {
  QUALIFIED = 'qualified',
  NOT_QUALIFIED = 'not_qualified',
  DUPLICATED = 'duplicated',
}

export const FORM_LOCALES = ['en', 'es'] as const;
export type FormLocale = (typeof FORM_LOCALES)[number];

export enum FormContentType {
  QUESTION = 'question',
  CARD = 'card',
  CONTACT = 'contact',
}

/** Defensive cap for nested-question recursion (builder, schema and runtime engine). */
export const MAX_NESTED_QUESTION_DEPTH = 5;

/**
 * Canonical question type vocabulary. Values match the `question_type` enum member
 * names emitted by the Prisma client, so a question read from the database flows
 * straight into the renderer with no mapping step.
 */
export enum FormAnswerType {
  LABELED_MULTIPLE_OPTIONS = 'labeled_multiple_options',
  LABELED_SINGLE_OPTION = 'labeled_single_option',
  DROPDOWN_MULTIPLE_OPTIONS = 'dropdown_multiple_options',
  DROPDOWN_SINGLE_OPTION = 'dropdown_single_option',
  ADDRESS = 'address',
  BOOLEAN = 'boolean',
  COLOR = 'color',
  EMAIL = 'email',
  DATE = 'date',
  NUMBER = 'number',
  PHONE = 'phone',
  POSTAL_CODE = 'postal_code',
  SHORT_TEXT = 'short_text',
  LONG_TEXT = 'long_text',
}

/** String union of `FormAnswerType` values, assignable from plain string literals. */
export type FormAnswerTypeValue = `${FormAnswerType}`;

/** Every `FormAnswerType` value, for building Zod enums that stay assignable from Prisma literals. */
export const FORM_ANSWER_TYPES = Object.values(FormAnswerType) as [
  FormAnswerTypeValue,
  ...FormAnswerTypeValue[],
];

export const QUESTION_TYPE_WITH_OPTIONS_LABELS: Partial<Record<FormAnswerTypeValue, string>> = {
  [FormAnswerType.LABELED_SINGLE_OPTION]: 'Single Option',
  [FormAnswerType.LABELED_MULTIPLE_OPTIONS]: 'Multiple Options',
  [FormAnswerType.DROPDOWN_SINGLE_OPTION]: 'Dropdown Single Option',
  [FormAnswerType.DROPDOWN_MULTIPLE_OPTIONS]: 'Dropdown Multiple Options',
};

/** The subset of `FormAnswerType` an administrator can pick when creating a question. */
export const QUESTION_TYPE_LABELS: Partial<Record<FormAnswerTypeValue, string>> = {
  [FormAnswerType.SHORT_TEXT]: 'Short Text',
  [FormAnswerType.LONG_TEXT]: 'Long Text',
  [FormAnswerType.BOOLEAN]: 'Yes/No',
  [FormAnswerType.ADDRESS]: 'Address',
  [FormAnswerType.PHONE]: 'Phone Number',
  [FormAnswerType.EMAIL]: 'Email Address',
  [FormAnswerType.DATE]: 'Date',
  [FormAnswerType.NUMBER]: 'Number',
  [FormAnswerType.POSTAL_CODE]: 'Postal Code',
  ...QUESTION_TYPE_WITH_OPTIONS_LABELS,
};

export const TYPES_WITH_OPTIONS = Object.keys(
  QUESTION_TYPE_WITH_OPTIONS_LABELS
) as FormAnswerTypeValue[];

export const QUESTION_TYPES = Object.keys(QUESTION_TYPE_LABELS) as [
  FormAnswerTypeValue,
  ...FormAnswerTypeValue[],
];

/**
 * Answer types a step can auto-advance from: picking an option is the whole answer, so
 * there is nothing left to click "Next" for. Multiple-choice types are excluded — every
 * question reads as answered on the first tick, which would cut off further selections.
 */
export const AUTO_NEXT_ANSWER_TYPES: FormAnswerTypeValue[] = [
  FormAnswerType.LABELED_SINGLE_OPTION,
  FormAnswerType.DROPDOWN_SINGLE_OPTION,
  FormAnswerType.BOOLEAN,
];

/** Answer keys of the fixed fields the `contact` block always collects. */
export const CONTACT_FIELD_KEYS = [
  'first_name',
  'last_name',
  'phone',
  'zip_code',
  'email',
  'details',
] as const;

export type ContactFieldKey = (typeof CONTACT_FIELD_KEYS)[number];

export type ContactFieldDescriptor = {
  key: ContactFieldKey;
  label: string;
  type: FormAnswerTypeValue;
  placeholder: string;
  /** Required fields gate the contact block's completion; optional ones do not. */
  required: boolean;
};

/**
 * The fixed contact fields, in their default order. The builder lists these as
 * reorder-only items (they cannot be removed), and the renderer paints each with
 * the control matching its `type`. Selected questions are interleaved among them.
 */
export const CONTACT_FIELDS: ContactFieldDescriptor[] = [
  {
    key: 'first_name',
    label: 'First Name',
    type: FormAnswerType.SHORT_TEXT,
    placeholder: 'John',
    required: true,
  },
  {
    key: 'last_name',
    label: 'Last Name',
    type: FormAnswerType.SHORT_TEXT,
    placeholder: 'Doe',
    required: true,
  },
  {
    key: 'phone',
    label: 'Phone Number',
    type: FormAnswerType.PHONE,
    placeholder: '(555) 000-0000',
    required: true,
  },
  {
    key: 'zip_code',
    label: 'Zip Code',
    type: FormAnswerType.POSTAL_CODE,
    placeholder: '90210',
    required: true,
  },
  {
    key: 'email',
    label: 'Email Address',
    type: FormAnswerType.EMAIL,
    placeholder: 'john@example.com',
    required: true,
  },
  {
    key: 'details',
    label: 'Case Details (Optional)',
    type: FormAnswerType.LONG_TEXT,
    placeholder: 'Tell us more about your situation...',
    required: false,
  },
];

export const INITIAL_FORM_METADATA = {
  i18n: {
    en: {
      messages: {
        qualified: `<div style="margin: 10px; padding: 20px; background: rgb(248, 249, 250)"><div style="text-align:center; margin: 0;" class="icon_valid"><div style="width: 50px; height: 50px; background-color: #28a745; border-radius: 50%; display: inline-block; position: relative;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="width: 30px; height: 30px; fill: white; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" aria-hidden="true"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg><span class="sr-only">Success</span></div></div><p style="text-align:center; font-size: 22px"><strong>YOUR EVALUATION HAS BEEN ACCEPTED.</strong></p><p>&nbsp;</p><p style="font-size:18px">Your evaluation has been accepted, and a legal associate will reach out to you shortly to verify your claim details and guide you through the next steps. If you need immediate assistance, please don’t hesitate to call us toll-free at <a style="color:#28a745" href="tel:18889418637">(888) 941-8637</a>, available daily from 8 AM to 7 PM CST.</p></div>`,
        not_qualified: `<div style="margin: 10px; padding: 20px; background: rgb(248, 249, 250)"><div style="text-align:center; margin: 0;" class="icon_valid"><div style="width: 50px; height: 50px; background-color: #ebb91e; border-radius: 50%; display: inline-block; position: relative;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style="width: 30px; height: 30px; fill: white; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" aria-hidden="true"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg><span class="sr-only">Success</span></div></div><p style="text-align:center; font-size: 22px"><strong>YOUR EVALUATION IS UNDER REVIEW.</strong></p><p>&nbsp;</p><p style="font-size:18px">Your application is currently under review. All applications go through a secondary review by our team, and we may contact you if we determine that you meet the eligibility criteria.</p></div>`,
        duplicated: `<div style="margin: 10px; padding: 20px; background: rgb(248, 249, 250)"><div style="text-align:center; margin: 0;" class="icon_valid"><div style="width: 50px; height: 50px; background-color: #990000; border-radius: 50%; display: inline-block; position: relative;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style="width: 30px; height: 30px; fill: white; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" aria-hidden="true"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg><span class="sr-only">Success</span></div></div><p style="text-align:center; font-size: 22px"><strong>CLAIM ALREADY SENT.</strong></p><p>&nbsp;</p><p style="font-size:18px;text-align:left">Thank you for your interest. Our records indicate you have already submitted a claim for this matter. To continue the process, please call us at <a href='tel:+18885080836' style='color: #28a745; text-decoration: none;'>(888) 508-0836</a> between 8 AM – 7 PM.</p></div>`,
      },
    },
    es: {
      messages: {
        qualified: `<div style="margin: 10px; padding: 20px; background: rgb(248, 249, 250)"><div style="text-align:center; margin: 0;" class="icon_valid"><div style="width: 50px; height: 50px; background-color: #28a745; border-radius: 50%; display: inline-block; position: relative;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="width: 30px; height: 30px; fill: white; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" aria-hidden="true"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg><span class="sr-only">Success</span></div></div><p style="text-align:center; font-size: 22px"><strong>SU EVALUACIÓN HA SIDO ACEPTADA.</strong></p><p>&nbsp;</p><p style="font-size:18px">Su evaluación ha sido aceptada y un asesor legal se comunicará con usted en breve para verificar los detalles de su reclamo y guiarlo en los próximos pasos. Si necesita asistencia inmediata, no dude en llamarnos sin cargo al <a style="color:#28a745" href="tel:18889418637">(888) 941-8637</a>, disponible todos los días de 8 a. m. a 7 p. m. CST.</p></div>`,
        not_qualified: `<div style="margin: 10px; padding: 20px; background: rgb(248, 249, 250)"><div style="text-align:center; margin: 0;" class="icon_valid"><div style="width: 50px; height: 50px; background-color: #ebb91e; border-radius: 50%; display: inline-block; position: relative;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style="width: 30px; height: 30px; fill: white; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" aria-hidden="true"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg><span class="sr-only">Success</span></div></div><p style="text-align:center; font-size: 22px"><strong>YOUR EVALUATION IS UNDER REVIEW.</strong></p><p>&nbsp;</p><p style="font-size:18px">Su solicitud se encuentra actualmente en proceso de revisión. Todas las solicitudes pasan por una revisión secundaria realizada por nuestro equipo, y es posible que nos pongamos en contacto con usted si determinamos que cumple con los criterios de elegibilidad.</p></div>`,
        duplicated: `<div style="margin: 10px; padding: 20px; background: rgb(248, 249, 250)"><div style="text-align:center; margin: 0;" class="icon_valid"><div style="width: 50px; height: 50px; background-color: #990000; border-radius: 50%; display: inline-block; position: relative;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style="width: 30px; height: 30px; fill: white; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" aria-hidden="true"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg><span class="sr-only">Success</span></div></div><p style="text-align:center; font-size: 22px"><strong>CLAIM ALREADY SENT.</strong></p><p>&nbsp;</p><p style="font-size:18px;text-align:left">Gracias por su interés. Nuestros registros indican que ya ha presentado una reclamación sobre este asunto. Para continuar con el proceso, llámenos al <a href='tel:+18885080836' style='color: #28a745; text-decoration: none;'>(888) 508-0836</a> entre las 8 AM – 7 PM.</p></div>`,
      },
    },
  },
};
